/** Module-cached brand campaigns list for dashboard omnibar indexing. */

const CAMPAIGNS_TTL_MS = 30000;

const cache = {
  data: [],
  fetchedAt: 0,
};

let inFlight = null;

export function resetOmnibarCampaignsCache() {
  cache.data = [];
  cache.fetchedAt = 0;
  inFlight = null;
}

/**
 * Shared GET /api/campaigns with TTL + single-flight.
 * @param {boolean} [force]
 * @returns {Promise<Array>}
 */
export async function fetchBrandCampaignsForOmnibar(force = false) {
  const now = Date.now();
  if (!force && cache.fetchedAt && (now - cache.fetchedAt) < CAMPAIGNS_TTL_MS) {
    return cache.data;
  }
  if (inFlight) {
    return inFlight;
  }

  inFlight = (async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return [];
      }
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/campaigns`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        return cache.data;
      }
      const data = await response.json();
      const list = Array.isArray(data) ? data : [];
      cache.data = list;
      cache.fetchedAt = Date.now();
      return list;
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
}
